import { css } from 'emotion'
import { Link, Colors } from './..'
import { Easings } from '../core';

// Default Button 
const defaultButton = {
  display: 'inline-block',
  position: 'relative',
  width: '100%',
  border: 0,
  ...Link,
  height: 60,
  background: Colors.extraLightGrey,
  transition: 'all 400ms ease',
  cursor: 'pointer',
  margin: '2rem 0px',
  '.btn--label': {
    transition: 'all 400ms ease',
  },
  '&:hover': {
    background: 'black',
    '.btn--label': {
      color: 'white',
    },
    'svg': {
      fill: 'white',
    }
  },
}

// Button Base -> With Load or not
export const ButtonStyle = (theme, isLoaded) => css({
  ...defaultButton,
  background: theme === 'grey' ? Colors.extraLightGrey : Colors.red,
  '.btn--label': {
    opacity: isLoaded ? 0 : 1,
    transition: 'opacity 200ms ease',
    lineHeight: '60px',
    color: theme === 'grey' ? 'black' : 'white',
    transition: 'all 400ms ease',
    'svg': {
      verticalAlign: 'middle',
      marginRight: '1rem',
      transition: 'fill 400ms ease',
    }
  },
  '.btn--load': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10,
    opacity: isLoaded ? 1 : 0,
    transition: 'opacity 200ms ease',
    'stop': {
      stopColor: '#000000',
    }
  },
}, {
  '&:hover': {
    '.btn--load': {
      'stop': {
        stopColor: '#ffffff',
      }
    }
  }
})

// Link 
export const LinkButtonStyle = css({
  ...defaultButton,
  lineHeight: '60px',
  color: 'black',
  'svg': {
    verticalAlign: 'middle',
    marginRight: '1rem',
    transition: 'fill 400ms ease',
  }
})

/*
* Button Card -
* PDFButton
* BookmarkButton
*/ 
export const ButtonCard = (big) => css({
  position: 'relative',
  display: 'block',
  background: Colors.extraLightGrey,
  width: '60px',
  height: '60px',
  border: 0,
  cursor: 'pointer',
  textAlign: 'center',
  '@media (min-width: 1024px)': {
    width: big ? '80px' : '60px',
    height: big ? '80px' : '60px',
  },
  '& svg': {
    fill: Colors.mediumGrey,
    transition: 'all 200ms ease',
    verticalAlign: 'middle',
    transform: 'translateX(2px)',
  },
  '&:hover': {
    '& svg': {
      fill: 'black',
    }
  }
})

/*
Return Card 
*/
export const ButtonReturnCard = (big) => css({
  width: big ? '80px' : '60px',
  height: big ? '80px' : '60px',
  background: 'none',
  border: 0,
  cursor: 'pointer',
  '& svg': {
    fill: Colors.mediumGrey,
    transition: 'fill 200ms ease',
  },

  '&:hover': {
    'svg': {
      fill: 'black',
    }
  }
})

// PDF
export const ButtonPDFCard = css({
  position: 'relative',
  'a.btn, button': {
    display: 'block',
    lineHeight: '60px',
    '@media (min-width: 1024px)': {
      // lineHeight: '80px', 
    }
  },
})

// Push Button 
export const LinkButtonPush = css({
  ...Link,
  display: 'inline-block',
  border: `1px solid ${Colors.mediumGrey}`,
  padding: '1rem 4rem',
  color: Colors.mediumGrey,
  position:'relative',
  transition: 'all 200ms ease',
  zIndex: 1,
  overflow: 'hidden',
  '&:hover':{
    color: 'black',
    background: 'white',
  }
})

export const ButtonWhite = {
  ...Link,
  background: 'white',
  height: 60,
  lineHeight: '60px',

  '&:hover': {
    background: 'black',
  }
}

export const ButtonRouter = css({
  justifyContent: 'center',
  'li > a': {
    ...Link,
    display: 'block',
    padding: '0px 1.5rem',
    height: 60,
    lineHeight: '60px',
    background: Colors.extraLightGrey,
    borderRight: '1px solid #FFF',
    'span': {
      color: 'black',
    },
    'svg': {
      verticalAlign: 'text-bottom',
      marginRight: '0.5rem',
    },
    '&:hover': {
      background: Colors.lightGrey,
    },
    '&.active': {
      background: 'black',
      'span': {
        color: 'white',
      },
      'svg': {
        fill: 'white',
      }
    }
  }
})

// Buton load More
export const ButtonLoadMoreStyle = css({
  'button.btn-load-more': {
    ...Link,
    textAlign: 'center',
    margin: '2rem auto',
    boreder: `1px solid ${Colors.lightGrey}`,
    padding: '1rem 2rem',
    color: Colors.grey,
    background: 'none',
    display: 'flex',
    fontSize: '0.75rem',
    transition: 'all 400ms ease',
    cursor: 'pointer',
    '&:hover': {
      color: 'white',
      background: 'black',
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/button.js